'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var modules_be025dea = {"container":"Select_module_container__1300b05b","menu":"Select_module_menu__1300b05b","icon":"Select_module_icon__1300b05b","is-arrow-turned":"Select_module_isArrowTurned__1300b05b"};
require("../../../assets/cjs/components/Select/src/Select~D5TMOwbY.css");

exports.default = modules_be025dea;
//# sourceMappingURL=Select.module.less.js.map
